import "./Footer.css";
import barcode from "./img/app_qr.png";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "./Global.js";
import useAppImages from "./components/AppImages";
import ReactHtmlParser from "html-react-parser";

const strapiServerUrl = window.strapiServerUrl;
const googleAppLink = window.googleAppLink;
const appleAppLink = window.appleAppLink;

const Footer = () => {

  const [appImages, sectionDesc] = useAppImages();
  const [footerImage, setFooterImage] = useState(null);
  const [footerImageDesc, setFooterImageDesc] = useState(null);

  useEffect(() => {
    if (appImages) {
      setFooterImage(appImages["footer"]);
    }
    if (sectionDesc) {
      setFooterImageDesc(sectionDesc["footer"]);
    }
  }, [appImages, sectionDesc]);

  const handlePhoneLinkClick = (event) => {
    if (window.innerWidth >= 768) {
      event.preventDefault();
    }
  };

  return (
    <footer>
      <div className="footer-main-container">
        <div className="footer-overlap-section">
          <div className="middle-content">
            <div className="vertical-section">
              {footerImageDesc && <h3>{ReactHtmlParser(footerImageDesc)}</h3>}
              <div className="vertical-section-buttons">
                <div className="button-container">
                  <a
                    href={googleAppLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="download-btn">
                      <i
                        className="fab fa-google-play"
                        style={{ color: "d40808" }}
                      ></i>
                      Download App
                    </button>
                  </a>
                  <a
                    href={appleAppLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="download-btn">
                      <i className="fab fa-apple fa-lg"></i>
                      Download App
                    </button>
                  </a>
                </div>
                <img src={barcode} width="100px" height="100px" alt="Barcode" />
              </div>
            </div>
            <div className="image-section">
              {footerImage && (
                <img src={`${strapiServerUrl}${footerImage}`} alt="img" />
              )}
            </div>
          </div>
        </div>
        <div className="footer-container">
          <div className="footer-column footer-column1">
            <h3>RennaMobile </h3>
            <p>
              Block No.204, SE40, Building No 302
              <br />
              Al Romelah Street 41, Al Wattyah
              <br />
              Muscat, Sultanate of Oman
            </p>
            <div>
              <ul className="footer-social-icons">
                <li>
                  <a
                    href="https://www.facebook.com/rennamobileoman"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-square-facebook"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://instagram.com/rennamobileoman"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-column footer-column2">
            <h3>
              <Link className="ceo_link" to="/ceo-speaks">
                CEO Speaks:
              </Link>
            </h3>
          </div>
          <div className="footer-column footer-column3">
            <h3>Contact Us</h3>
            <ul>
          


	<li>
	<a
	  href="tel:1240"
	  id="phoneLink"
	  className="terms_link"
	  onClick={handlePhoneLinkClick}
	>
	  <i className="fa fa-phone"></i>1240 (7:00 am - 1:00 am)
	</a>
	</li>


	<li>
	<a
	  href="tel:+96891600000"
	  id="phoneLink"
	  className="terms_link"
	  onClick={handlePhoneLinkClick}
	>
	  <i className="fa fa-phone"></i>91600000 (7:00 am - 1:00 am)
	</a>
	</li>

	  
              <li>
                <a href="mailto:info@rennamobile.com" className="terms_link">
                  <i className="fa-sharp fa-regular fa-envelope"></i>
                  info@rennamobile.com
                </a>
              </li>
              <li>
                <a
                  href="https://maps.app.goo.gl/8y53GN7gfGj6g1oy7?g_st=ic"
                  className="terms_link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-location-dot"></i>wattayah-muscat
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>@Renna Mobile.2023 AIl Rights Reserved.</p>
          <p>
            <Link className="terms_link" to="/terms-and-conditions">
              Terms & Conditions
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
